import React, { useEffect, useRef, useState } from "react";
import { v4 as uuidv4 } from "uuid";
import {
  Button,
  Divider,
  FormFieldSet,
  Modal,
  PageHeader,
  PageTitle,
  showToast,
  useFormHandler,
  AttachmentSection,
  DocumentsList,
} from "../../../../../../components";
import { H1BStatus, WADocStatus } from "../../../../../../assets/data/enumData";
import { WADocType } from "../../../../../../assets/data/projectData";

//Dropdown data
import useDropdownData from "../../../../../../hooks/useDropdownData";
import { useSelector, useDispatch } from "react-redux";
import { filterEmptyValues } from "../../../../../../utils/filterEmptyValues";
import { useLoginUser } from "../../../../../../hooks/useLoginUser";
//Dropdown data end
import {
  addNewWorkAuthStart,
  getWorkauthsStart,
} from "../../../../../../redux/slices/workauths/workauthsSlice";
import { uploadStart } from "../../../../../../redux/slices/universal/fileUploadSlice";
import { addDocumentStart } from "../../../../../../redux/slices/universal/documentsSlice";
import { transformFiles } from "../../../../../../utils/transformFiles";

const WorkAuthorizationModal = ({
  isOpen,
  onClose,
  edit = false,
  selectedRow,
}) => {
  const dispatch = useDispatch();
  const { userData: loginUserData } = useLoginUser();
  const loginUserUiid = loginUserData?.uiid;
  const { employeeProfileUiid } = useSelector((state) => state.employee);
  const [validationRules, setValidationRules] = useState({});
  const DOC_TYPES_WITH_EAD = ["Green Card", "H4", "OPT"];
  const DOC_TYPES_WITH_H1B = ["H-1B"];
  const initialFormData = {
    country: "",
    documentType: "",
    ead: [],
    H1BStatus: "",
    H1BRecord: "",
    dummyText: "",
    documentNumber: undefined,
    documentStatus: "",
    dateIssued: "",
    validFrom: "",
    expiryDate: "",
    aNumber: undefined,
    comments: "",
    attachments: [
      {
        id: uuidv4(),
        attachmentName: "",
        attachmentComments: "",
        chooseFiles: [],
      },
    ],
  };

  const { formData, errors, handleChange, validateAllFields, setFormData } =
    useFormHandler(initialFormData, validationRules);

  useEffect(() => {
    const baseRules = {
      country: { type: "select", required: true },
      documentType: { type: "select", required: true },
      // ...(DOC_TYPES_WITH_EAD.includes(formData.documentType)
      //   ? {
      //       //ead: { type: "checkbox", required: true },
      //     }
      //   : {}),
      ...(DOC_TYPES_WITH_H1B.includes(formData.documentType)
        ? {
            H1BStatus: { type: "select", required: true },
            H1BRecord: { type: "select", required: true },
          }
        : {}),
      // documentNumber: { type: "text", required: true },
      // documentStatus: { type: "select", required: true },
      // dateIssued: { type: "date", required: true },
      // validFrom: { type: "date", required: true },
      // expiryDate: { type: "date", required: true },
      // aNumber: { type: "text", required: true },
      // comments: { type: "text", required: true },
      // attachments: formData.attachments.map(() => ({
      //   attachmentName: { type: "text", required: true },
      //   attachmentComments: { type: "text", required: true },
      //   chooseFiles: {
      //     type: "file",
      //     required: true,
      //     allowedFiles: [{ ext: "txt", mime: "text/plain" }],
      //   },
      // })),
      attachments: [ { chooseFiles: { type: "file" } } ]
    };
    setValidationRules(baseRules);
  }, [formData.documentType, formData.attachments.length]);

  ///////////////////////////////////////////////////
  //handel Attachment Error
  ///////////////////////////////////////////////////

  const getAttachmentError = (index, field) => {
    return errors?.attachments?.[index]?.[field] || "";
  };
  ///////////////////////////////////////////////////
  //handel Attachment Error end
  ///////////////////////////////////////////////////

  ///////////////////////////////////////////////////
  ///// Get select data form server//////////////////
  ///////////////////////////////////////////////////
  const containerRef = useRef(null);
  const { data: countryOptions, handleScroll: handleCountriesScroll } =
    useDropdownData("countries");
  ///////////////////////////////////////////////////
  ///// Get select data form server End
  ///////////////////////////////////////////////////

  ///////////////////Handel Save//////////////////////

  const handleSave = () => {
    const isValid = validateAllFields();

    if (isValid) {
      const userFormData = {
        employeeId: employeeProfileUiid,
        country: formData.country,
        documentType: formData.documentType,
        documentNum: formData.documentNumber,
        documentStatus: formData.documentStatus,
        issueDate: formData.dateIssued,
        validFrom: formData.validFrom,
        expiryDate: formData.expiryDate,
        aNum: formData.aNumber,
        comments: formData.comments,
      };

      // Add EAD field only for specific document types
      if (DOC_TYPES_WITH_EAD.includes(formData.documentType)) {
        userFormData.ead = formData.ead[0];
      }

      // Add H1B related fields only for H-1B document type
      if (DOC_TYPES_WITH_H1B.includes(formData.documentType)) {
        userFormData.H1BStatus = formData.H1BStatus;
        userFormData.H1BRecord = formData.H1BRecord;
      }

      const submissionData = filterEmptyValues(userFormData);
      const cleanAttachments = formData.attachments.filter(
        (att) =>
          att.attachmentName.trim() !== "" ||
          att.attachmentComments.trim() !== "" ||
          (att.chooseFiles && att.chooseFiles.length > 0)
      );
      dispatch(
        addNewWorkAuthStart({
          submissionData,
          coll: "WorkAuth",
          uiid: edit ? selectedRow?.uiid : "",
          onSuccess: async (payload) => {
            if (cleanAttachments?.length) {
              dispatch(
                uploadStart({
                  uploadType: "multiple",
                  field: "doc",
                  uiid: employeeProfileUiid,
                  entity: "employees",
                  category: "work authorization",
                  coll: "WorkAuth",
                  doc: cleanAttachments.flatMap((doc) =>
                    doc.chooseFiles.map((file) => {
                      file.id = doc.id;
                      return file;
                    })
                  ),
                  onSuccess: async (fileData) => {
                    // fileData response will be array format, since uploadType: "multiple"
                    dispatch(
                      
                      addDocumentStart({
                        coll: "Document",
                        refColl: "WorkAuth",
                        refId: payload?.data?.workAuthId || payload?.uiid || "",
                        refField: "documents",
                        payload: {
                          addedBy: loginUserUiid,
                          attachments: [
                            {
                         parent:{employee:employeeProfileUiid},
                              addedBy: loginUserUiid,
                              docType: "WorkAuth",
                              ref: {
                                id:
                                  payload?.data?.workAuthId ||
                                  payload?.uiid ||
                                  "", // parent doc uiid this doc belongs to
                                entity: "WorkAuth", // collection name this doc belongs to
                                path: `documents`,
                              },
                              file: cleanAttachments.map((obj) => ({
                                name: obj.attachmentName,
                                comments: obj.attachmentComments,
                                keys: fileData
                                  .filter(
                                    (file) =>
                                      file?.fileRefId === obj.id && file.key
                                  ) // match and ensure key exists
                                  .map((file) => file.key),
                              })),
                            },
                          ],
                        },
                        //onSuccess: handleModalClose,
                        onSuccess: () => {
                          dispatch(
                            getWorkauthsStart({
                              limit: 100, // Changed from lim to limit
                              page: 1, // Changed from pg to page
                              fil: {
                                employeeId: {
                                  type: "NONE",
                                  value: employeeProfileUiid,
                                },
                              },
                              cache: false,
                            })
                          );
                          handleModalClose();
                        },
                      })
                    );
                  },
                })
              );
            } else {
              dispatch(
                getWorkauthsStart({
                  limit: 100, // Changed from lim to limit
                  page: 1, // Changed from pg to page
                  fil: {
                    employeeId: { type: "NONE", value: employeeProfileUiid },
                  },
                  cache: false,
                })
              );
              handleModalClose();
            }
          },
        })
      );

      // showToast("Please fill in all required fields.", "success");
    } else {
      showToast("Please fill in all required fields.", "error");
    }
  };
  ///////////////////handel save end////////////////////

  const handleModalClose = () => {
    onClose(true);
    setFormData(initialFormData);
  };
  useEffect(() => {
    if (edit) {
      handleChange("country", selectedRow?.country);
      handleChange("documentType", selectedRow?.documentType);
      handleChange("documentNumber", selectedRow?.documentNum);
      handleChange("documentStatus", selectedRow?.documentStatus);
      handleChange("dateIssued", selectedRow?.issueDate);
      handleChange("validFrom", selectedRow?.validFrom);
      handleChange("ead", selectedRow?.ead);
      handleChange("H1BStatus", selectedRow?.H1BStatus);
      handleChange("H1BRecord", selectedRow?.H1BRecord);
      handleChange("dummyText", selectedRow?.dummyText);
      handleChange("documentNumber", selectedRow?.documentNum);
      handleChange("expiryDate", selectedRow?.expiryDate);
      handleChange("aNumber", selectedRow?.aNum);
      handleChange("comments", selectedRow?.comments);
    } else {
      setFormData(initialFormData);
    }
  }, [edit, selectedRow]);
  return (
    <Modal
      isOpen={isOpen}
      onClose={onClose}
      title={edit ? "Edit Work Authorization" : "Add Work Authorization"}
      width="max-w-7xl min-h-[500px]"
    >
      <div className="grid grid-cols-3 gap-6 items-start pt-3">
        <FormFieldSet
          type="select"
          title={"Country"}
          keyname={"countries"}
          placeholder="Select Country"
          value={formData.country}
          onChange={(value) => handleChange("country", value)}
          options={countryOptions}
          error={errors.country}
          refData={containerRef}
          handleScroll={() => handleCountriesScroll(containerRef)}
          required
        />

        <FormFieldSet
          type="select"
          title="Document Type"
          placeholder="Select"
          value={formData.documentType}
          onChange={(value) => handleChange("documentType", value)}
          error={errors.documentType}
          options={WADocType}
          showSearch
          //showButton //// need to clearyfy this
          required
        />
        {DOC_TYPES_WITH_EAD.includes(formData.documentType) && (
          <FormFieldSet
            type="checkbox"
            title=""
            options={[
              {
                label: "EAD",
                value: true,
              },
            ]}
            values={formData.ead || []}
            onChange={(value) => handleChange("ead", value)}
            multiple
            error={errors.ead}
          />
        )}
        {DOC_TYPES_WITH_H1B.includes(formData.documentType) && (
          <>
            <FormFieldSet
              type="select"
              title="H1B Status"
              placeholder="Select H-1B Status"
              value={formData.H1BStatus}
              onChange={(value) => handleChange("H1BStatus", value)}
              error={errors.H1BStatus}
            />
            <FormFieldSet
              type="select"
              title="H-1B Record"
              placeholder="Select H-1B Record"
              value={formData.H1BRecord}
              onChange={(value) => handleChange("H1BRecord", value)}
              error={errors.H1BRecord}
              options={H1BStatus}
            />
          </>
        )}

        <FormFieldSet
          type="text"
          title="Document Number"
          placeholder="Enter Document Number"
          value={formData.documentNumber}
          onChange={(value) => handleChange("documentNumber", value)}
          error={errors.documentNumber}
        />
        <FormFieldSet
          type="select"
          title="Document Status"
          placeholder="Select Document Status"
          value={formData.documentStatus}
          onChange={(value) => handleChange("documentStatus", value)}
          error={errors.documentStatus}
          options={WADocStatus}
        />
        <FormFieldSet
          type="datepicker"
          title="Date Issued"
          placeholder="Select Date Issued"
          value={formData.dateIssued}
          onChange={(value) => handleChange("dateIssued", value)}
          error={errors.dateIssued}
          showDropdown={false}
        />
        <FormFieldSet
          type="datepicker"
          title="Valid From"
          placeholder="Select Valid From"
          value={formData.validFrom}
          onChange={(value) => handleChange("validFrom", value)}
          error={errors.validFrom}
          showDropdown={false}
        />
        <FormFieldSet
          type="datepicker"
          title="Expiry Date"
          placeholder="Select Expiry Date"
          value={formData.expiryDate}
          onChange={(value) => handleChange("expiryDate", value)}
          error={errors.expiryDate}
          showDropdown={false}
        />
        <FormFieldSet
          type="text"
          title="A-Number"
          placeholder="Enter A-Number"
          value={formData.aNumber}
          onChange={(value) => handleChange("aNumber", value)}
          error={errors.aNumber}
        />
        <FormFieldSet
          type="textArea"
          title="Comments"
          placeholder="Enter Comments"
          value={formData.comments}
          onChange={(value) => handleChange("comments", value)}
          error={errors.comments}
        />
      </div>
      <div className="mt-3 mb-1">
        <PageHeader
          Section={
            <div className="flex">
              <PageTitle title="Attachments" tag="h6" />
            </div>
          }
        />
      </div>
      <Divider />
      {edit && (
        <DocumentsList
          data={transformFiles(selectedRow?.documents || [])}
          type="inner"
        />
      )}
      <AttachmentSection
        attachments={formData.attachments}
        onChange={(newAttachments) =>
          setFormData({ ...formData, attachments: newAttachments })
        }
        getAttachmentError={getAttachmentError}
        showNameField={true}
        showCommentsField={true}
      />

      <div className="flex gap-3 justify-end mb-10 mt-16">
        <Button title="Cancel" variant="outlined" onClick={onClose} />
        <Button title="Save" onClick={handleSave} />
      </div>
    </Modal>
  );
};

export default WorkAuthorizationModal;
